const divModalAction = {
  fileError: 'Wait for all files to upload'
};

export default divModalAction;
